import { ChangeDetectorRef, Component } from "@angular/core";
import { Validators } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { CorrectYeKeService } from "projects/sepidz-web-framework/src/lib/services";
import { of } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Element } from "src/app/backoffice/hrm/models/base-info/element.model";
import { FormulaInfo } from "src/app/backoffice/hrm/models/base-info/formula.model";
import { HrmDiskFormat } from "src/app/backoffice/hrm/models/base-info/hrm-disk-format.model";
import { ElementGroup } from "src/app/backoffice/hrm/models/enums/element-group";
import { ElementKind } from "src/app/backoffice/hrm/models/enums/element-kind";
@Component({
  selector: "ngx-hrm-disk-item-formula",
  templateUrl: "./hrm-disk-item-formula.component.html",
  styleUrls: ["./hrm-disk-item-formula.component.scss"],
})
export class HrmDiskItemFormulaFormComponent extends BaseFormComponent<HrmDiskFormat> {
  public apiName: string = "HrmDiskFormat";
  gridColumns: form_control[] = [];
  formulaInfo: FormulaInfo[];
  PropertyInfo: FormulaInfo[] = [];
  elements: Element[];
  _model: HrmDiskFormat;
  ActiveAdjustmentElemenet: Element[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.label = "قالب فایل خروجی";
    this.noLoadData = true;
    this.detailName = "HrmDiskItemFormats";

    super.ngOnInit();
    this.setFormulaInfo();
  }
  setdefault() {
    if (this.currentrow) {
      this.model[this.detailName] = Object.assign({}, this.currentrow);
    }
    if (!this.model?.HrmDiskItemFormats) this.model.HrmDiskItemFormats = [];
    if (this.model[this.detailName].IsConst === undefined) this.model[this.detailName].IsConst = false;
    if (this.model[this.detailName].SortID == undefined) this.model[this.detailName].SortID = (this._model?.HrmDiskItemFormats?.length ?? 0) + 1;
    if (this.model[this.detailName].IsParam === undefined) this.model[this.detailName].IsParam = false;
    if (this.model[this.detailName].IsCodepage === undefined) this.model[this.detailName].IsCodepage = false;

    if (this.model[this.detailName].PropertyInfo) {
      this.PropertyInfo = JSON.parse(this.model[this.detailName].PropertyInfo);
      this.model[this.detailName].FarsiName = this.replaceItemNames(this.model[this.detailName].FieldName);
    }
  }
  setColumnAttribute() {
    super.setColumnAttribute();
    let flag: boolean = !this.model[this.detailName];
    if (this.model[this.detailName])
      flag = (this.model[this.detailName].HrmDiskFormatDateKindCode ?? 0) < 5 || (this.model[this.detailName].HrmDiskFormatDateKindCode ?? 0) > 6;
    this.columns.forEach((x) => {
      if (x.name === "ConstFarsiField") x.disabled = this.formGroup?.get("IsConst")?.value !== true;
      if (x.name === "FarsiName") x.disabled = this.formGroup?.get("IsConst")?.value === true;

      if (x.name === "HrmDiskFormatDateKindId") x.disabled = flag;
    });
    if (this.formGroup) this.model = this.getDataFromFormGroup();
    this.setFormGroup(this.model[this.detailName]);
  }
  setFormulaInfo() {
    this.formulaInfo = [];
    if (this.elements && this.elements.length > 0) {
      this.formulaInfo.push(this.getpersonelInfo());
      this.formulaInfo.push(this.getElement());
    } else {
      this.httpCommonService
        .getList("Element")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            this.elements = data as [];
            this.formulaInfo.push(this.getpersonelInfo());
            this.formulaInfo.push(this.getElement());
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
  getElement() {
    const element: FormulaInfo = <FormulaInfo>{};
    element.Title = "عوامل";
    element.key = "element";
    element.items = [];

    element.items.push(this.getEmploymentOrderElement());
    element.items.push(this.getComputationalElement());
    element.items.push(this.getMonthlyInputElement());
    element.items.push(this.getLoanElement());
    return element;
  }

  getEmploymentOrderElement() {
    const EmploymentOrder: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.Title = "حکمی";
    EmploymentOrder.key = "EmploymentOrder";
    EmploymentOrder.items = [];

    const Bonus: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.items.push(Bonus);
    Bonus.Title = "مزایا";
    Bonus.key = "Bonus";
    Bonus.items = [];
    const EMP: FormulaInfo = <FormulaInfo>{};
    Bonus.items.push(EMP);
    EMP.Title = "حکم معادل";
    EMP.key = "EMP";
    EMP.items = [];
    const FMEMP: FormulaInfo = <FormulaInfo>{};
    Bonus.items.push(FMEMP);
    FMEMP.Title = "اولین حکم ماه";
    FMEMP.key = "FMEMP";
    FMEMP.items = [];
    const LMEMP: FormulaInfo = <FormulaInfo>{};
    Bonus.items.push(LMEMP);
    LMEMP.Title = "آخرین حکم ماه";
    LMEMP.key = "LMEMP";
    LMEMP.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Bonus && x.ElementKindCode === ElementKind.EmploymentOrder)
        .forEach((x) => {
          this.getNode(x as Element, EMP, "");
          this.getNode(x as Element, FMEMP, "");
          this.getNode(x as Element, LMEMP, "");
        });
    }
    const Deduct: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.items.push(Deduct);
    Deduct.Title = "کسور";
    Deduct.key = "Deduct";
    Deduct.items = [];
    const DEMP: FormulaInfo = <FormulaInfo>{};
    Deduct.items.push(DEMP);
    DEMP.Title = "حکم معادل";
    DEMP.key = "EMP";
    DEMP.items = [];
    const FMDEMP: FormulaInfo = <FormulaInfo>{};
    Deduct.items.push(FMDEMP);
    FMDEMP.Title = "اولین حکم ماه";
    FMDEMP.key = "FMEMP";
    FMDEMP.items = [];
    const LMDEMP: FormulaInfo = <FormulaInfo>{};
    Deduct.items.push(LMDEMP);
    LMDEMP.Title = "آخرین حکم ماه";
    LMDEMP.key = "LMEMP";
    LMDEMP.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Deduct && x.ElementKindCode === ElementKind.EmploymentOrder)
        .forEach((x) => {
          this.getNode(x as Element, DEMP, "");
          this.getNode(x as Element, FMDEMP, "");
          this.getNode(x as Element, LMDEMP, "");
        });
    }

    const Boss: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.items.push(Boss);
    Boss.Title = "تعهدات";
    Boss.key = "Boss";
    Boss.items = [];
    const BEMP: FormulaInfo = <FormulaInfo>{};
    Boss.items.push(BEMP);
    BEMP.Title = "حکم معادل";
    BEMP.key = "EMP";
    BEMP.items = [];
    const FMBEMP: FormulaInfo = <FormulaInfo>{};
    Boss.items.push(FMBEMP);
    FMBEMP.Title = "اولین حکم ماه";
    FMBEMP.key = "FMEMP";
    FMBEMP.items = [];
    const LMBEMP: FormulaInfo = <FormulaInfo>{};
    Boss.items.push(LMBEMP);
    LMBEMP.Title = "آخرین حکم ماه";
    LMBEMP.key = "LMEMP";
    LMBEMP.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Boss && x.ElementKindCode === ElementKind.EmploymentOrder)
        .forEach((x) => {
          this.getNode(x as Element, BEMP, "");
          this.getNode(x as Element, FMBEMP, "");
          this.getNode(x as Element, LMBEMP, "");
        });
    }
    const Works: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.items.push(Works);
    Works.Title = "کارکرد";
    Works.key = "Works";
    Works.items = [];
    const WEMP: FormulaInfo = <FormulaInfo>{};
    Works.items.push(WEMP);
    WEMP.Title = "حکم معادل";
    WEMP.key = "EMP";
    WEMP.items = [];
    const FMWEMP: FormulaInfo = <FormulaInfo>{};
    Works.items.push(FMWEMP);
    FMWEMP.Title = "اولین حکم ماه";
    FMWEMP.key = "FMEMP";
    FMWEMP.items = [];
    const LMWEMP: FormulaInfo = <FormulaInfo>{};
    Works.items.push(LMWEMP);
    LMWEMP.Title = "آخرین حکم ماه";
    LMWEMP.key = "LMEMP";
    LMWEMP.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Work && x.ElementKindCode === ElementKind.EmploymentOrder)
        .forEach((x) => {
          this.getNode(x as Element, WEMP, "");
          this.getNode(x as Element, FMWEMP, "");
          this.getNode(x as Element, LMWEMP, "");
        });
    }
    const Others: FormulaInfo = <FormulaInfo>{};
    EmploymentOrder.items.push(Others);
    Others.Title = "سایر";
    Others.key = "Others";
    Others.items = [];
    const OEMP: FormulaInfo = <FormulaInfo>{};
    Others.items.push(OEMP);
    OEMP.Title = "حکم معادل";
    OEMP.key = "EMP";
    OEMP.items = [];
    const FMOEMP: FormulaInfo = <FormulaInfo>{};
    Others.items.push(FMOEMP);
    FMOEMP.Title = "اولین حکم ماه";
    FMOEMP.key = "FMEMP";
    FMOEMP.items = [];
    const LMOEMP: FormulaInfo = <FormulaInfo>{};
    Others.items.push(LMWEMP);
    LMOEMP.Title = "آخرین حکم ماه";
    LMOEMP.key = "LMEMP";
    LMOEMP.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Other && x.ElementKindCode === ElementKind.EmploymentOrder)
        .forEach((x) => {
          this.getNode(x as Element, OEMP, "");
          this.getNode(x as Element, FMOEMP, "");
          this.getNode(x as Element, LMOEMP, "");
        });
    }
    return EmploymentOrder;
  }
  getNode(Row: Element, Node: FormulaInfo, kind: string) {
    const p: FormulaInfo = <FormulaInfo>{};
    p.Title = "محاسباتی";
    p.key = Node.key + "_" + Row["Id"].toString();
    p.items = [];
    if (kind.includes("X")) p.Formula = "Tax_" + Node.key + "_" + Row["Id"].toString() + ",EYear,EMonth,TaxGroupRef)";
    else p.Formula = Node.key + "_" + Row["Id"].toString();
    p.Title = `${Node.Title}_${Row["Title"]}`;
    Node.items.push(p);
  }

  getComputationalElement() {
    const Computational: FormulaInfo = <FormulaInfo>{};
    Computational.Title = "محاسباتی";
    Computational.key = "Computational";
    Computational.items = [];

    const Bonus: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Bonus);
    Bonus.Title = "مزایا";
    Bonus.key = "MV";
    Bonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Bonus)
        .forEach((x) => {
          this.getNode(x as Element, Bonus, "");
        });
    }

    const Deduct: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Deduct);
    Deduct.Title = "کسور";
    Deduct.key = "MV";
    Deduct.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Deduct)
        .forEach((x) => {
          this.getNode(x as Element, Deduct, "");
        });
    }
    const Boss: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Boss);
    Boss.Title = "تعهدات";
    Boss.key = "MV";
    Boss.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Boss)
        .forEach((x) => {
          this.getNode(x as Element, Boss, "");
        });
    }
    const Others: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Others);
    Others.Title = "سایر";
    Others.key = "MV";
    Others.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Other)
        .forEach((x) => {
          this.getNode(x as Element, Others, "");
        });
    }

    const EndYearBonus: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(EndYearBonus);
    EndYearBonus.Title = "عيدي و پاداش آخر سال";
    EndYearBonus.key = "EndYearBonus";
    EndYearBonus.items = [];

    const RewardSaveBonus: FormulaInfo = <FormulaInfo>{};
    EndYearBonus.items.push(RewardSaveBonus);
    RewardSaveBonus.Title = "ذخیره عیدی";
    RewardSaveBonus.key = "RSMV";
    RewardSaveBonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.RwrdSave)
        .forEach((x) => {
          this.getNode(x as Element, RewardSaveBonus, "");
        });
    }
    const RewardPaymentBonus: FormulaInfo = <FormulaInfo>{};
    EndYearBonus.items.push(RewardPaymentBonus);
    RewardPaymentBonus.Title = "هزینه عیدی";
    RewardPaymentBonus.key = "RPMV";
    RewardPaymentBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.RwrdPay)
        .forEach((x) => {
          this.getNode(x as Element, RewardPaymentBonus, "");
        });
    }
    const Buy: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Buy);
    Buy.Title = "ذخيره سنوات";
    Buy.key = "Buy";
    Buy.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.EstablishmentTheReserveOfYearsOfService)
        .forEach((x) => {
          this.getNode(x as Element, Buy, "");
        });
    }
    const Vacation: FormulaInfo = <FormulaInfo>{};
    Computational.items.push(Vacation);
    Vacation.Title = "مرخصی";
    Vacation.key = "Vacation";
    Vacation.items = [];
    const VacationSaveBonus: FormulaInfo = <FormulaInfo>{};
    Vacation.items.push(VacationSaveBonus);
    VacationSaveBonus.Title = "ذخیره مرخصی";
    VacationSaveBonus.key = "VSMV";
    VacationSaveBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.VacationSave)
        .forEach((x) => {
          this.getNode(x as Element, Vacation, "");
        });
    }
    const VacationPaymentBonus: FormulaInfo = <FormulaInfo>{};
    Vacation.items.push(VacationPaymentBonus);
    VacationPaymentBonus.Title = "بازخرید مرخصی";
    VacationPaymentBonus.key = "VPMV";
    VacationPaymentBonus.items = [];
    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.VacationBuy)
        .forEach((x) => {
          this.getNode(x as Element, VacationPaymentBonus, "");
        });
    }

    return Computational;
  }
  getMonthlyInputElement() {
    const MonthlyInput: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.Title = "ماهانه(فرم ورودی)";
    MonthlyInput.key = "MonthlyInput";
    MonthlyInput.items = [];

    const Bonus: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.items.push(Bonus);
    Bonus.Title = "مزایا";
    Bonus.key = "MW";
    Bonus.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Bonus && x.ElementKindCode === ElementKind.InputForm)
        .forEach((x) => {
          this.getNode(x as Element, Bonus, "");
        });
    }
    const Work: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.items.push(Work);
    Work.Title = "کارکرد";
    Work.key = "MW";
    Work.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Work && x.ElementKindCode === ElementKind.InputForm)
        .forEach((x) => {
          this.getNode(x as Element, Work, "");
        });
    }
    const Deduct: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.items.push(Deduct);
    Deduct.Title = "کسور";
    Deduct.key = "MW";
    Deduct.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Deduct && x.ElementKindCode === ElementKind.InputForm)
        .forEach((x) => {
          this.getNode(x as Element, Deduct, "");
        });
    }
    const Boss: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.items.push(Boss);
    Boss.Title = "تعهدات";
    Boss.key = "MW";
    Boss.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Boss && x.ElementKindCode === ElementKind.InputForm)
        .forEach((x) => {
          this.getNode(x as Element, Boss, "");
        });
    }
    const Others: FormulaInfo = <FormulaInfo>{};
    MonthlyInput.items.push(Others);
    Others.Title = "سایر";
    Others.key = "MW";
    Others.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Other && x.ElementKindCode === ElementKind.InputForm)
        .forEach((x) => {
          this.getNode(x as Element, Others, "");
        });
    }
    return MonthlyInput;
  }
  getLoanElement() {
    const Loan: FormulaInfo = <FormulaInfo>{};
    Loan.Title = "وام کارکنان";
    Loan.key = "Loan";
    Loan.items = [];

    const LoanInstallments: FormulaInfo = <FormulaInfo>{};
    Loan.items.push(LoanInstallments);
    LoanInstallments.Title = "قسط وام";
    LoanInstallments.key = "L";
    LoanInstallments.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Loan && x.ElementKindCode === ElementKind.Computational)
        .forEach((x) => {
          this.getNode(x as Element, LoanInstallments, "");
        });
    }
    const LoanPyed: FormulaInfo = <FormulaInfo>{};
    Loan.items.push(LoanPyed);
    LoanPyed.Title = "جمع اقساط پرداخت شده";
    LoanPyed.key = "LP";
    LoanPyed.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Loan && x.ElementKindCode === ElementKind.Computational)
        .forEach((x) => {
          this.getNode(x as Element, LoanPyed, "");
        });
    }
    const LoanOrignal: FormulaInfo = <FormulaInfo>{};
    Loan.items.push(LoanOrignal);
    LoanOrignal.Title = "اصل وام";
    LoanOrignal.key = "LO";
    LoanOrignal.items = [];

    if (this.elements && this.elements.length > 0) {
      this.elements
        .filter((x) => x.ElementGroupCode === ElementGroup.Loan && x.ElementKindCode === ElementKind.Computational)
        .forEach((x) => {
          this.getNode(x as Element, LoanOrignal, "");
        });
    }
    return Loan;
  }
  getBankAccountInfo() {
    const empKind: FormulaInfo = <FormulaInfo>{};
    empKind.Title = "حساب بانكي";
    empKind.key = "BankAccount";
    empKind.items = [];

    const BankTitle: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(BankTitle);
    BankTitle.Title = "محل پرداخت";
    BankTitle.key = "BankTitle";
    BankTitle.Formula = "BankTitle";

    const AccountType: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(AccountType);
    AccountType.Title = "نوع حساب";
    AccountType.key = "AccountType";
    AccountType.Formula = "AccountType";

    const BankAccount: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(BankAccount);
    BankAccount.Title = "شماره حساب";
    BankAccount.key = "BankAccount";
    BankAccount.Formula = "BankAccount";

    const BankAccount2: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(BankAccount2);
    BankAccount2.Title = "شماره حساب 2";
    BankAccount2.key = "BankAccount2";
    BankAccount2.Formula = "BankAccount2";

    const BankAccount3: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(BankAccount3);
    BankAccount3.Title = "شماره حساب 3";
    BankAccount3.key = "BankAccount3";
    BankAccount3.Formula = "BankAccount3";

    const BankAccount4: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(BankAccount4);
    BankAccount4.Title = "شماره حساب 4";
    BankAccount4.key = "BankAccount4";
    BankAccount4.Formula = "BankAccount4";

    const BankAccount5: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(BankAccount5);
    BankAccount5.Title = "شماره حساب 5";
    BankAccount5.key = "BankAccount5";
    BankAccount5.Formula = "BankAccount5";

    return empKind;
  }
  getTaxInfo() {
    const empKind: FormulaInfo = <FormulaInfo>{};
    empKind.Title = "اطلاعات ماليات";
    empKind.key = "TaxBranch";
    empKind.items = [];

    const PostCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(PostCode);
    PostCode.Title = "كد پستي";
    PostCode.key = "PostCode";
    PostCode.Formula = "PostCode";

    const EducationCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(EducationCode);
    EducationCode.Title = "كد مدرك تحصيلي";
    EducationCode.key = "EducationCode";
    EducationCode.Formula = "EducationCode";

    const SerialCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(SerialCode);
    SerialCode.Title = "كد رسته";
    SerialCode.key = "RastehCode";
    SerialCode.Formula = "RastehCode";

    const TaxFreeCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TaxFreeCode);
    TaxFreeCode.Title = "كد معافيت مالياتي";
    TaxFreeCode.key = "TaxFreeCode";
    TaxFreeCode.Formula = "TaxFreeCode";

    const MeliatCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(MeliatCode);
    MeliatCode.Title = "كد مليت";
    MeliatCode.key = "MeliatCode";
    MeliatCode.Formula = "MeliatCode";

    const TaxBranchTitle: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TaxBranchTitle);
    TaxBranchTitle.Title = "حوزه مالیاتی";
    TaxBranchTitle.key = "TaxBranchTitle";
    TaxBranchTitle.Formula = "TaxBranchTitle";

    const TB_BranchID: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TB_BranchID);
    TB_BranchID.Title = "كد حوزه ماليات";
    TB_BranchID.key = "BranchID";
    TB_BranchID.Formula = "BranchID";

    const TB_CompName: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TB_CompName);
    TB_CompName.Title = "نام شركت";
    TB_CompName.key = "CompName";
    TB_CompName.Formula = "CompName";

    const TB_farm: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TB_farm);
    TB_farm.Title = "نام كارفرما";
    TB_farm.key = "EmployerName";
    TB_farm.Formula = "EmployerName";

    const TB_adrs: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TB_adrs);
    TB_adrs.Title = "آدرس شركت";
    TB_adrs.key = "EmployerAddress";
    TB_adrs.Formula = "EmployerAddress";

    const EconomicNumber: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(EconomicNumber);
    EconomicNumber.Title = "شماره اقتصادي كارفرما";
    EconomicNumber.key = "EconomicNumber";
    EconomicNumber.Formula = "EconomicNumber";

    const TB_ZipCode: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TB_ZipCode);
    TB_ZipCode.Title = "كد پستي كارفرما";
    TB_ZipCode.key = "ZipCode";
    TB_ZipCode.Formula = "ZipCode";

    const TB_PhoneNumber: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TB_PhoneNumber);
    TB_PhoneNumber.Title = "شماره تلفن";
    TB_PhoneNumber.key = "PhoneNumber";
    TB_PhoneNumber.Formula = "PhoneNumber";

    const TB_OwnerNationalNumber: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TB_OwnerNationalNumber);
    TB_OwnerNationalNumber.Title = "كد ملي صاحب امضاء اول";
    TB_OwnerNationalNumber.key = "OwnerNationalNumber";
    TB_OwnerNationalNumber.Formula = "OwnerNationalNumber";

    const TB_OwnerFirstName: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TB_OwnerFirstName);
    TB_OwnerFirstName.Title = "نام صاحب امضاء اول";
    TB_OwnerFirstName.key = "OwnerFirstName";
    TB_OwnerFirstName.Formula = "OwnerFirstName";

    const TB_OwnerLastName: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TB_OwnerLastName);
    TB_OwnerLastName.Title = "نام خانوادگی صاحب امضاء اول";
    TB_OwnerLastName.key = "OwnerLastName";
    TB_OwnerLastName.Formula = "OwnerLastName";

    const TB_OwnerPost: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(TB_OwnerPost);
    TB_OwnerPost.Title = "سمت صاحب امضاء اول";
    TB_OwnerPost.key = "OwnerPost";
    TB_OwnerPost.Formula = "OwnerPost";

    return empKind;
  }
  getEmployment() {
    const empKind: FormulaInfo = <FormulaInfo>{};
    empKind.Title = "استخدامی";
    empKind.key = "EmpKind";
    empKind.items = [];

    const OrganizationUnitTitle: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(OrganizationUnitTitle);
    OrganizationUnitTitle.Title = "واحد سازماني شخص";
    OrganizationUnitTitle.key = "OrganizationUnitTitle";
    OrganizationUnitTitle.Formula = "OrganizationUnitTitle";

    const JobTitle: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(JobTitle);
    JobTitle.Title = "شغل شخص";
    JobTitle.key = "JobTitle";
    JobTitle.Formula = "JobTitle";

    const PositionTitle: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(PositionTitle);
    PositionTitle.Title = "پست شخص";
    PositionTitle.key = "PositionTitle";
    PositionTitle.Formula = "PositionTitle";

    const EmploymentKindTitle: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(EmploymentKindTitle);
    EmploymentKindTitle.Title = "نوع استخدام شخص";
    EmploymentKindTitle.key = "EmploymentKindTitle";
    EmploymentKindTitle.Formula = "EmploymentKindTitle";

    const PersWorkplaceTitle: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(PersWorkplaceTitle);
    PersWorkplaceTitle.Title = "محل خدمت شخص";
    PersWorkplaceTitle.key = "PersWorkplaceTitle";
    PersWorkplaceTitle.Formula = "PersWorkplaceTitle";

    const PersCostCenterTitle: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(PersCostCenterTitle);
    PersCostCenterTitle.Title = "مركز هزينه شخص";
    PersCostCenterTitle.key = "PersCostCenterTitle";
    PersCostCenterTitle.Formula = "PersCostCenterTitle";

    const InsBranchTitle: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(InsBranchTitle);
    InsBranchTitle.Title = "شعبه بيمه";
    InsBranchTitle.key = "InsBranchTitle";
    InsBranchTitle.Formula = "InsBranchTitle";

    const InsueID: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(InsueID);
    InsueID.Title = "شماره بيمه";
    InsueID.key = "InsueID";
    InsueID.Formula = "InsueID";

    const IB_BranchID: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(IB_BranchID);
    IB_BranchID.Title = "كد كارگاه";
    IB_BranchID.key = "IB_BranchID";
    IB_BranchID.Formula = "IB_BranchID";

    const EMPStartDate: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(EMPStartDate);
    EMPStartDate.Title = "تاریخ استخدام";
    EMPStartDate.key = "EMPStartDate";
    EMPStartDate.Formula = "EMPStartDate";

    const EmpEndDate: FormulaInfo = <FormulaInfo>{};
    empKind.items.push(EmpEndDate);
    EmpEndDate.Title = "تاریخ پایان خدمت";
    EmpEndDate.key = "EmpEndDate";
    EmpEndDate.Formula = "EmpEndDate";

    return empKind;
  }
  getpersonelInfo() {
    const personelInfo: FormulaInfo = <FormulaInfo>{};
    personelInfo.Title = "مشخصات کارکنان";
    personelInfo.key = "PersonelInfo";
    personelInfo.items = [];
    personelInfo.items.push(this.getIDCard());
    personelInfo.items.push(this.getEmployment());
    personelInfo.items.push(this.getBankAccountInfo());
    personelInfo.items.push(this.getTaxInfo());

    const CurrentDate: FormulaInfo = <FormulaInfo>{};
    personelInfo.items.push(CurrentDate);
    CurrentDate.Title = "تاريخ";
    CurrentDate.key = "CurrentDate";
    CurrentDate.Formula = "CurrentDate";

    const CurrentYear: FormulaInfo = <FormulaInfo>{};
    personelInfo.items.push(CurrentYear);
    CurrentYear.Title = "سال";
    CurrentYear.key = "CurrentYear";
    CurrentYear.Formula = "CurrentYear";

    const CurrentMonth: FormulaInfo = <FormulaInfo>{};
    personelInfo.items.push(CurrentMonth);
    CurrentMonth.Title = "ماه";
    CurrentMonth.key = "CurrentMonth";
    CurrentMonth.Formula = "CurrentMonth";

    const SanavatYear: FormulaInfo = <FormulaInfo>{};
    personelInfo.items.push(SanavatYear);
    SanavatYear.Title = "سنوات خدمت(سابقه درون سازماني به سال)";
    SanavatYear.key = "SanavatYear";
    SanavatYear.Formula = "SanavatYear";

    const SanavatMonth: FormulaInfo = <FormulaInfo>{};
    personelInfo.items.push(SanavatMonth);
    SanavatMonth.Title = "سنوات خدمت(سابقه درون سازماني به ماه)";
    SanavatMonth.key = "SanavatMonth";
    SanavatMonth.Formula = "SanavatMonth";

    const SanavatDays: FormulaInfo = <FormulaInfo>{};
    personelInfo.items.push(SanavatDays);
    SanavatDays.Title = "سنوا خدمت (سابقه درون سازماني به روز)";
    SanavatDays.key = "SanavatDays";
    SanavatDays.Formula = "SanavatDays";
    return personelInfo;
  }

  public hasChildren = (item: any) => item.items && item.items.length > 0;
  public fetchChildren = (item: any) => of(item.items);
  getIDCard() {
    const IDCard: FormulaInfo = <FormulaInfo>{};
    IDCard.Title = "شناسنامه ای";
    IDCard.key = "IDCard";
    IDCard.items = [];

    const PersCode: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(PersCode);
    PersCode.Title = "کد پرسنلی";
    PersCode.key = "PersCode";
    PersCode.Formula = "PersCode";

    const FirstName: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(FirstName);
    FirstName.Title = "نام";
    FirstName.key = "FirstName";
    FirstName.Formula = "FirstName";

    const LastName: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(LastName);
    LastName.Title = "نام خانوادگی";
    LastName.key = "LastName";
    LastName.Formula = "LastName";

    const FatherName: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(FatherName);
    FatherName.Title = "نام پدر";
    FatherName.key = "FatherName";
    FatherName.Formula = "FatherName";

    const CertificateID: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(CertificateID);
    CertificateID.Title = "شماره شناسنامه";
    CertificateID.key = "CertificateID";
    CertificateID.Formula = "CertificateID";

    const SexualityCode: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(SexualityCode);
    SexualityCode.Title = "جنسیت شخص";
    SexualityCode.key = "SexualityCode";
    SexualityCode.Formula = "SexualityCode";

    const BirthDate: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(BirthDate);
    BirthDate.Title = "تاريخ تولد شخص";
    BirthDate.key = "BirthDate";
    BirthDate.Formula = "BirthDate";

    const NationalID: FormulaInfo = <FormulaInfo>{};
    IDCard.items.push(NationalID);
    NationalID.Title = "كد ملي";
    NationalID.key = "NationalID";
    NationalID.Formula = "NationalID";

    return IDCard;
  }
  valueChangeWithName($event) {
    if ($event && $event?.name === "IsConst") {
      this.setColumnAttribute();
      if (this.formGroup?.get("IsConst")?.value === true) {
        this.formGroup?.get("ConstFarsiField")?.enable();
        this.formGroup?.get("ConstFarsiField")?.setValidators(Validators.required);
        this.columns.find((x) => x.name === "ConstFarsiField").disabled = false;
        this.formGroup?.get("FarsiName")?.disable();
        this.formGroup?.get("FarsiName").clearValidators();
        this.columns.find((x) => x.name === "FarsiName").disabled = true;
      } else {
        this.formGroup?.get("ConstFarsiField")?.disable();
        this.formGroup?.get("ConstFarsiField")?.clearValidators();
        this.columns.find((x) => x.name === "ConstFarsiField").disabled = true;
        this.formGroup?.get("FarsiName")?.enable();
        this.formGroup?.get("FarsiName")?.setValidators(Validators.required);
        this.columns.find((x) => x.name === "FarsiName").disabled = false;
      }
      this.cd.markForCheck();
    }
  }
  onValueChangeByApiName($event) {
    if (
      $event &&
      $event.apiName &&
      $event.data &&
      $event.data.Id &&
      $event.apiName.includes("Lookup") &&
      $event.data.Category === "HrmDiskFormatValueKind"
    ) {
      this.setValue("HrmDiskFormatDateKindCode", $event.data.Code);
      this.setValue("HrmDiskFormatDateKindTitle", $event.data.Title);
      this.model[this.detailName].HrmDiskFormatDateKindCode = $event.data.Code;
      this.model[this.detailName].HrmDiskFormatDateKindTitle = $event.data.Title;
      this.setColumnAttribute();
    }
  }
  addItem(selected: any) {
    if (this.formGroup?.get("IsConst")?.value === true || !selected?.dataItem) return;
    if (selected && selected.dataItem) {
      if (selected.dataItem.items && selected.dataItem.items.lengh > 0) return;
      selected.dataItem.Title = CorrectYeKeService.getCorrectYeKe(selected.dataItem.Title);
      if (!this.PropertyInfo) this.PropertyInfo = [];
      const text = this.wrap(selected.dataItem.Title);

      if (!this.PropertyInfo.some((x) => x.key === selected.dataItem.key)) this.PropertyInfo.push(selected.dataItem);
      else this.PropertyInfo.find((x) => x.key === selected.dataItem.key).Title = selected.dataItem.Title;
      let value = this.formGroup.controls["FarsiName"].value;
      if (
        value &&
        (value[value.length - 1] === "+" || value[value.length - 1] === "-" || value[value.length - 1] === "*" || value[value.length - 1] === "/")
      )
        value = `${value}${text}`;
      else value = text;
      this.formGroup.controls["FarsiName"].setValue(value);
      if (!this.formGroup?.controls["ColumnPersianTitle"]?.value) this.formGroup.controls["ColumnPersianTitle"].setValue(selected.dataItem.Title);
      this.formGroup.updateValueAndValidity();
      setTimeout(() => this.cd.markForCheck(), 100);
    }
  }

  wrap(text) {
    return `[${text}]`;
  }
  public async save() {
    if (!this.formGroup.valid) return;
    this.model = this.getDataFromFormGroup();

    this.result = this.model[this.detailName];
    if (this.result.IsConst === true) this.result.FieldName = this.result.ConstFarsiField;
    else this.result.FieldName = this.replaceItemValues(this.result.FarsiName);
    if (this.PropertyInfo && this.PropertyInfo.length > 0) this.result.PropertyInfo = JSON.stringify(this.PropertyInfo);
    else this.result.PropertyInfo = undefined;
    this.close();
  }
  private replaceItemValues(value: string): string {
    this.PropertyInfo.forEach((t) => {
      value.replace(this.wrap(t.Title), t.Formula);
    });
    return value;
  }

  private replaceItemNames(value: string): string {
    if (!value) {
      return;
    }
    this.PropertyInfo.forEach((t) => {
      value = value.replace(t.Formula, this.wrap(t.Title));
    });
    return value;
  }
}
